import React from 'react';
import UserIcon from '../icons/UserIcon';
/**
 * A component that looks like a faded transaction item, that is supposed
 * to teach the users where they can find their transactions.
 */
const TransactionListFooter = () => (
    <div className="tjt-gradient-border hidden lg:block">
        <div className="flex items-center">
            <UserIcon />{' '}
            <span className="text-12 ml-8">
                Finn dine handler på torget under Min FINN
            </span>
        </div>
    </div>
);

export default TransactionListFooter;
